import * as React from "react"
import styled from "styled-components"

import { Line } from "../../interfaces/SaleorTypes"
import { HorizontalSpacer } from "../../atoms/spacers"
import ConfirmationItemCard from "./ConfirmationItemCard"
import BodyMedium from "../../atoms/typography/BodyMedium"

interface ConfirmationAccessorySectionProps {
  lines: Line[]
  status: String
}

const SubHeaderWrapper = styled.div`
  margin-bottom: 0.4em;
`

const Divider = styled.div`
  border: solid 1px #898989;
`

const ConfirmationAccessoryContainer = styled.table`
  width: 100%;
  margin-top: 1em;
`

const ConfirmationAccessorySection: React.FunctionComponent<ConfirmationAccessorySectionProps> = ({
  lines,
  status,
  ...props
}) => {
  const checkIfCategoryExists = () => {
    let flag = false
    lines.map((item: Line) => {
      if (item.variant.product?.category.name == "Accessories") {
        flag = true
      }
    })
    return flag
  }

  const renderAccessories = () => {
    return (
      lines.length > 0 &&
      lines.map(
        (item: Line, index: any) =>
          item.variant.product?.category.name == "Accessories" && (
            <ConfirmationItemCard status={status} key={index} line={item} />
          ),
      )
    )
  }

  return (
    <div>
      {lines && lines.length > 0 && checkIfCategoryExists() && (
        <div>
          <HorizontalSpacer spacing={1} />
          <SubHeaderWrapper>
            <BodyMedium>Accessories</BodyMedium>
          </SubHeaderWrapper>
          <Divider />
          <ConfirmationAccessoryContainer>{renderAccessories()}</ConfirmationAccessoryContainer>
        </div>
      )}
    </div>
  )
}

export default ConfirmationAccessorySection
